<div *ngIf="showPickASlot && !showSuccess">
  <app-pick-a-slot
    [bookADemoObj]="bookADemoObj"
    [loader]="loader"
    (pickASlotEmitter)="slotEvent($event)"
  >
  </app-pick-a-slot>
</div>

<div class="form-sec sec-padding">
  <div class="container" [hidden]="showPickASlot || showSuccess">
    
    <div class="book-demo-form mx-auto mw-900">

      <div class="row mx-0">
        <div class="col-md-6 col-sm-12 p-0">
          <div class="top-sec">
            <h1 class="heading-one text-white"> {{ "Bookdemo.BookdemoTitlesub" | translate }} </h1>
            <p class="paragraph-global-text text-white">{{ "Bookdemo.BookdemoParagraph" | translate }}</p>
            <div class="about-us-rgt">
              <figure>
                <img loading="lazy" width="250" height="200" src="../../assets/images/book-demo/book-demo-banner-removebg-preview.png" alt="book a demo banner img">
              </figure>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-sm-12 right-sec">

          <div class="">
            <h2 class="heading-two mb-2">Book a demo</h2>
            <p class="paragraph-global-text mb-5 pb-3">Kindly share your essential details with us to enable a personalized and insightful interaction with our sales team.</p>
          </div>
      
          <div class="book-demo-lft w-100">
            <form name="bookADemoForm" id="bookADemoForm">
              <div class="formgrid">
                <label class="form-label">Company name</label>
                <div class="field">
                  <input
                    type="text"
                    pInputText
                    [(ngModel)]="bookADemoObj.companyName"
                    name="companyName"
                    id="companyName"
                    placeholder="Company name"
                    class="error-text text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                    required
                    minlength="3"
                    maxlength="40"
                  />
                </div>
              </div>
              <div class="formgrid mobile-contact-person">
                <div class="field">
                  <label class="form-label">Contact person name</label>
                  <input
                    type="text"
                    pInputText
                    [(ngModel)]="bookADemoObj.contactName"
                    name="contactName"
                    id="contactName"
                    placeholder="Contact person name"
                    class="error-text text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                    required
                    minlength="3"
                    maxlength="30"
                  />
                </div>
                <div class="field flex flex-column preferred-time-width">
                  <label class="form-label">Work email</label>
                  <input
                    type="text"
                    pInputText
                    [(ngModel)]="bookADemoObj.email"
                    name="contactEmail"
                    id="contactEmail"
                    placeholder="Work email"
                    class="error-text text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                    required
                    [ngClass]="{ error: !isDomainValid }"
                  />
                  <small class="error" *ngIf="!isDomainValid"
                    >Invalid work email.</small
                  >
                </div>
              </div>
              <div class="formgrid grid mobile-contact-person">
                
                <div class="field col w-100 flex-1">
                  <label class="form-label">Job role</label>
                  <p-autoComplete
                    id="designation"
                    class="w-100"
                    styleClass="w-100"
                    [suggestions]="designations"
                    placeholder="What is your role?"
                    (completeMethod)="onDesignationSearch($event)"
                    field="designation"
                    [virtualScroll]="true"
                    [virtualScrollItemSize]="20"
                    [required]="true"
                    [showEmptyMessage]="true"
                    [forceSelection]="true"
                    [lazy]="true"
                    styleClass="w-full flex-column full-width error-text"
                    [(ngModel)]="userDesignationId"
                    (onSelect)="setDesignationId()"
                    [required]="true"
                  >
                  </p-autoComplete>
                </div>
              </div>
              <div class="formgrid grid mobile-contact-person desktop-view">
                <div class="formgrid field col p-0">
                  <div class="display-flex">
                    <label class="w-25 col-4 form-label">Prefix</label>
                    <label class="w-75 col-8 form-label">Phone number</label>
                  </div>
                  <div class="display-flex phone-field">
                  <!-- <p-dropdown
                     name="phonePrefix"
                     id="phonePrefix"
                     [options]="phonePrefixes"
                     [autoDisplayFirst]="true"
                     filter="true"
                     optionValue="countryCode"
                     optionLabel="phonePrefix"
                     placeholder="Prefix"
                     [required]="true"
                     [(ngModel)]="bookADemoObj.phoneNumCountryCode"
                     (onChange)="onPrefixChange($event)"
                   >
                   <ng-template let-option pTemplate="item">
                    <span>{{ option.phonePrefix }}  {{ option.countryName }}</span>
                  </ng-template>
                   </p-dropdown> -->
                   <mat-form-field class="w-25 col-4 px-0" floatLabel="never">
                    <mat-select [placeholder]="'Prefix'"
                      [(ngModel)]="bookADemoObj.phoneNumCountryCode"
                      name="phonePrefix"
                      required
                      (selectionChange)="onPrefixChange($event)"
                    >
                      <mat-option *ngFor="let prefix of phonePrefixes" [value]="prefix.countryCode">
                        {{ prefix.phonePrefix }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <p-inputNumber
                    [(ngModel)]="bookADemoObj.phone"
                    name="contactNumber"
                    id="contactNumber"
                    placeholder="Phone number"
                    inputStyleClass="col flex-column"
                    styleClass="error-text flex"
                    [useGrouping]="false"
                    [required]="true"
                    minlength="10"
                    maxlength="10"
                    class="col-9 w-75"
                  ></p-inputNumber>
                  </div>
                </div>
                <div class="field col flex flex-column display-flex">
                  <label class="form-label">No of employess</label>
                  <!-- <p-inputNumber
                    id="noOfEmployees"
                    placeholder="No of employees"
                    inputStyleClass="w-full"
                    styleClass="error-text flex"
                    [showButtons]="true"
                    [useGrouping]="false"
                    [maxlength]="10"
                    [(ngModel)]="bookADemoObj.noOfEmployees"
                    name="noOfEmployees"
                    [required]="true"
                  ></p-inputNumber> -->
                  <!-- <p-dropdown
                  name="noOfEmployees"
                  id="noOfEmployees"
                  [options]="noOfEmployees"
                  [autoDisplayFirst]="false"
                  optionLabel="name"
                  optionValue="id"
                  placeholder="No of employees"
                  styleClass="w-full"
                  [required]="true"
                  [(ngModel)]="bookADemoObj.noOfEmployees"
                >
                </p-dropdown> -->
                <mat-form-field class="w-full" floatLabel="never">
                  <mat-select [placeholder]="'No of employees'" [(ngModel)]="bookADemoObj.noOfEmployees" name="noOfEmployees" required>
                    <mat-option *ngFor="let employeeOption of noOfEmployees" [value]="employeeOption.id">
                      {{ employeeOption.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                </div>
              </div>
              <div class="formgrid mobile-contact-person">
                <div class="field">
                  <div class="field-checkbox my-1 d-block gap-6 mobile-contact-person">
                    <ng-container *ngFor="let type of demoType">
                      <div class="flex flex-nowrap gap-3 mb-3">
                        <p-radioButton
                          [inputId]="'demoType_' + type.id"
                          name="demoType"
                          styleClass="error-text"
                          [value]="type.id"
                          [(ngModel)]="bookADemoObj.demoType"
                        ></p-radioButton>
                        <label [for]="'demoType_' + type.id">{{ type.name }}</label>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
              <div class="formgrid mobile-contact-person">
                <div class="field flex flex-column preferred-time-width flex-1" >
                  <label class="form-label">{{bookADemoObj.demoType == 1
                    ? 'What skills you are looking for?'
                    : 'What skillset you want to offer to customers?'}}</label>
                  <!-- <p-multiSelect
                    [options]="skillGroups"
                    name="skillGroups"
                    id="skillGroups"
                    optionLabel="name"
                    optionValue="id"
                    display="chip"
                    filterPlaceHolder="Search"
                    [showToggleAll]="false"
                    [virtualScroll]="true"
                    [itemSize]="20"
                    required="true"
                    placeholder="{{
                      bookADemoObj.demoType == 1
                        ? 'What skills you are looking for?'
                        : 'What skillset you want to offer to customers?'
                    }}"
                    styleClass="w-full error-text"
                    [(ngModel)]="bookADemoObj.skillGroupIds"
                    (onChange)="onChangeSkillGroups($event)"
                  >
                  </p-multiSelect> -->
                  <mat-form-field class="" floatLabel="never">
                    <mat-select
                      multiple
                      [(ngModel)]="bookADemoObj.skillGroupIds"
                      (selectionChange)="onChangeSkillGroups($event)"
                    >
                      <mat-option *ngFor="let skillGroup of skillGroups" [value]="skillGroup.id">
                        {{ skillGroup.name }}
                      </mat-option>
                    </mat-select>
                    <mat-placeholder>
                      {{
                        bookADemoObj.demoType == 1
                          ? 'What skills you are looking for?'
                          : 'What skillset you want to offer to customers?'
                      }}
                    </mat-placeholder>
                  </mat-form-field>            
                  <small id="skillGroupsError" class="error d-none">Required!</small>
                </div>
                
                <div class="field col p-0 w-100 flex-1">
                  <label class="form-label">Location</label>
                  <p-autoComplete
                    id="locationInfo"
                    class="w-100"
                    name="locationInfo"
                    styleClass="w-100 flex-column"
                    [suggestions]="locations"
                    placeholder="Where is your business located?"
                    (completeMethod)="onLocationSearch($event)"
                    field="formattedName"
                    [virtualScroll]="true"
                    [virtualScrollItemSize]="20"
                    [required]="true"
                    [showEmptyMessage]="true"
                    [forceSelection]="true"
                    [lazy]="true"
                    styleClass="w-full full-width error-text"
                    [(ngModel)]="bookADemoObj.locationInfo"
                    [required]="true"
                  >
                  </p-autoComplete>
                </div>
              </div>
              <div class="formgrid">
                <div class="field w-full">
                  <label class="form-label">How did you hear about us?</label>
                  <!-- <p-dropdown
                    name="howDoYouHearAboutUs"
                    id="howDoYouHearAboutUs"
                    [options]="platformApporachTypes"
                    [autoDisplayFirst]="false"
                    optionLabel="name"
                    optionValue="name"
                    placeholder="How did you hear about us? (Optional)"
                    styleClass="w-full"
                    [(ngModel)]="bookADemoObj.howDoYouHearAboutUs"
                  >
                  </p-dropdown> -->
                  <mat-form-field class="w-full" floatLabel="never">
                    <mat-select [placeholder]="'Ex. Google'" [(ngModel)]="bookADemoObj.howDoYouHearAboutUs" name="howDoYouHearAboutUs">
                      <mat-option *ngFor="let platform of platformApporachTypes" [value]="platform.name">
                        {{ platform.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="field w-full">
                  <label class="form-label">How can we help you?</label>
                  <textarea
                    pInputTextarea
                    [autoResize]="true"
                    rows="3"
                    placeholder="How can we help you?"
                    [(ngModel)]="bookADemoObj.comment"
                    maxlength="2000"
                    class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                  ></textarea>
                </div>
                <div class="check-block">
                  <mat-checkbox
                    class="error-text example-margin"
                    (change)="agreeTermsAndPolicy($event.checked)"
                  >
                    <p>
                      {{ "Bookdemo.agreeAumnics" | translate }}
                      <a [routerLink]="['/', languageCode, 'user-agreement']"
                      >{{ "Bookdemo.TermsService" | translate }}</a>
                      {{ "Bookdemo.and" | translate }}
                      <a [routerLink]="['/', languageCode, 'privacy-policy']"
                        >{{ "Footer.PrivacyPolicy" | translate }}.</a
                      >
                      {{ "Bookdemo.anyTime" | translate }}
                    </p>
                  </mat-checkbox>
                </div>
                <div class="captch-block">
                  <p-captcha
                    id="recaptcha"
                    [siteKey]="env.CAPTCHA_SITE_KEY"
                    (onResponse)="validateCaptcha()"
                    (onExpire)="validateCaptcha()"
                  >
                  </p-captcha>
                  <p id="recaptchaError" class="error d-none">
                    {{ "placeHolders.required" | translate }}
                  </p>
                </div>
              </div>
              <button [disabled]="loader || !acceptTerms" (click)="schedule()" class="save-btn cfa w-100 mt-4 mb-2">
                <i class="pi pi-spin pi-spinner" *ngIf="loader"></i>
                <span *ngIf="!loader">{{ "buttons.submit" | translate }}</span>
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="confirmed" *ngIf="showSuccess">
     <img loading="lazy" src="{{ bookdemoPathUrl + '/book-demo/confirmed.svg' }}" alt="confirmed">
     <h4 class="heading-one">Confirmed</h4>
     <h5>You have a scheduled demo with the Amy team.</h5>

    <div class="confirmed-cont">
        <ul>
          <li>
            <img loading="lazy" src="{{ bookdemoPathUrl + '/book-demo/time.svg' }}" alt="time">
            <b>30 minutes meeting with Amy team</b>
          </li>
          <li>
            <img loading="lazy" src="{{ bookdemoPathUrl + '/book-demo/calendar.svg' }}" alt="calender">
            <span>{{
              bookADemoObj.demoTime | date : "MMM dd yyyy, hh:mm a"
            }}</span>
          </li>
          <li>
            <img loading="lazy" src="{{ bookdemoPathUrl + '/book-demo/map.svg' }}" alt="timezone">
            <span>{{ bookADemoObj?.timezoneInfo?.ftimeZone }}</span>
          </li>
          <li>
            <img loading="lazy" src="{{ bookdemoPathUrl + '/book-demo/video.svg' }}" alt="video">
            <span>Web conferencing</span>
          </li>

         
        </ul>
        <small>Meeting invitation email will be sent to you shortly.</small>
    </div>
    <button class="showMore-btn" (click)="reset()">Go to Home</button>

</div>
